import { render } from "./HeaderNotificationsNotifyError.vue?vue&type=template&id=83654036&scoped=true"
import script from "./HeaderNotificationsNotifyError.vue?vue&type=script&lang=js"
export * from "./HeaderNotificationsNotifyError.vue?vue&type=script&lang=js"

import "./HeaderNotificationsNotifyError.vue?vue&type=style&index=0&id=83654036&lang=scss&scoped=true"
import "./HeaderNotificationsNotifyError.vue?vue&type=style&index=1&id=83654036&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83654036"]])

export default __exports__